<section class="bg-white shadow-sm p-6 w-full max-w-xl mx-auto">

  <h1 class="text-lg font-semibold text-gray-800 mb-4 border-b pb-2">
    Seleccione los Módulos
  </h1>

  <!-- Lista de módulos -->
  <section class="flex flex-col gap-3">

    <div *ngFor="let module of dataMapped" class="p-3 border rounded-lg">

      <!-- Toggle principal -->
      <mat-slide-toggle [(ngModel)]="module.selected" (change)="toggleModule(module)" color="primary">
        {{ module.label }}
      </mat-slide-toggle>

      <!-- Submenús -->
      <!-- <div *ngIf="module.showSubmenu && module.subMenu.length > 0" class="ml-8 mt-3 flex flex-col gap-2 border-l pl-4">

        <mat-slide-toggle *ngFor="let sub of module.subMenu" [(ngModel)]="sub.selected"
          (change)="toggleSubmodule(module, sub)" color="accent">
          {{ sub.label }}
        </mat-slide-toggle>


      </div> -->
<!-- Submenús -->
<div *ngIf="module.showSubmenu && module.subMenu.length > 0"
     class="ml-8 mt-3 flex flex-col gap-2 border-l pl-4 submenu-toggle">

  <mat-slide-toggle *ngFor="let sub of module.subMenu"
    [(ngModel)]="sub.selected"
    (change)="toggleSubmodule(module, sub)"
    color="accent">
    {{ sub.label }}
  </mat-slide-toggle>

</div>



    </div>

  </section>

  <!-- Botón guardar -->
  <section class="flex justify-end mt-6">
    <button class="button-select text-white rounded-lg bg-color_box px-4 py-2" (click)="close()">
      Guardar
    </button>
  </section>

</section>